import { useState } from "react";
import { ChevronDown, ChevronUp } from "untitledui-js-base";
import { getFilterDisplayName } from "../../utils/getFilterDisplayName";
import { Show, Input, InputSize, Checkbox } from "shared/components";

export const FilterSection = ({
  title,
  options,
  optionLimit,
  selectedOptions,
  onChange
}: {
  title: string;
  options: { id?: string; name: string; count: number }[];
  optionLimit?: number;
  selectedOptions: string[];
  onChange: (name: string) => void;
}) => {
  const [expanded, setExpanded] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [search, setSearch] = useState("");

  const filterOptionsBySearch = (
    options: { id?: string; name: string; count: number }[],
    search: string
  ) => {
    return options.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  };

  const displayedOptions = showAll
    ? filterOptionsBySearch(options, search)
    : filterOptionsBySearch(options, search).slice(0, optionLimit);

  const shouldShowMoreButton =
    optionLimit &&
    displayedOptions.length >= optionLimit &&
    options.length > optionLimit;

  return (
    <div className="py-4">
      <button
        className=" w-full flex items-center justify-between cursor-pointer"
        onClick={() => setExpanded((prev) => !prev)}
      >
        <p className="text-content-1000 text-sm font-bold">{title}</p>
        {expanded ? <ChevronUp /> : <ChevronDown />}
      </button>

      <Show if={expanded}>
        <div className="mt-4">
          <Show if={!title.toLowerCase().includes("status")}>
            <Input
              id="search"
              autoComplete="off"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size={InputSize.SM}
              className="h-12 mb-4"
            />
          </Show>

          <Show if={!displayedOptions.length}>
            <p className="text-sm text-content-400">No options available</p>
          </Show>

          <div
            className="space-y-2"
            style={{
              maskImage:
                shouldShowMoreButton && !showAll
                  ? "linear-gradient(to bottom, rgba(0, 0, 0, 1.0) 0%, transparent 100%)"
                  : "none"
            }}
          >
            {displayedOptions.map((option) => (
              <Checkbox
                key={option.name}
                id={option.name}
                name={option.name}
                checked={selectedOptions.includes(option.id ?? option.name)}
                label={`${getFilterDisplayName(option.name)} (${option.count})`}
                labelClassName="whitespace-normal"
                onChange={() => onChange(option.id ?? option.name)}
              />
            ))}
          </div>
          <Show if={shouldShowMoreButton}>
            <button
              className="text-primary-500 text-sm mt-2 font-bold"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Show less" : "Show more"}
            </button>
          </Show>
        </div>
      </Show>
    </div>
  );
};
